var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditOrderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8105 12.0001L12.417 4.39356L11.3565 3.33306L3.75 10.9396V12.0001H4.8105ZM5.43225 13.5001H2.25V10.3178L10.8263 1.74156C10.9669 1.60096 11.1576 1.52197 11.3565 1.52197C11.5554 1.52197 11.7461 1.60096 11.8867 1.74156L14.0085 3.86331C14.1491 4.00396 14.2281 4.19469 14.2281 4.39356C14.2281 4.59244 14.1491 4.78317 14.0085 4.92381L5.43225 13.5001V13.5001ZM2.25 15.0001H15.75V16.5001H2.25V15.0001Z",
    fill: "#150823"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOrderIcon);
export default __webpack_public_path__ + "static/media/editOrder-icon.59ce5b1ce254de576f28b99cc89afabf.svg";
export { ForwardRef as ReactComponent };